<template>
    <div class="register-form">
      <h2>Pre-Order Now</h2>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="name">Name</label>
          <input
            type="text"
            id="name"
            v-model="formData.name"
            placeholder="Enter your name"
            required
          />
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            v-model="formData.email"
            placeholder="Enter your email"
            required
          />
        </div>
        <div class="form-group">
          <label for="message">Message (Optional)</label>
          <textarea
            id="message"
            v-model="formData.message"
            placeholder="Leave a message (optional)"
          ></textarea>
        </div>
        <button type="submit" class="btn">Submit</button>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    name: "RegisterForm",
    data() {
      return {
        formData: {
          name: "",
          email: "",
          message: "",
        },
      };
    },
    methods: {
      handleSubmit() {
        // Simulate form submission
        alert(`Thank you, ${this.formData.name}! Your pre-order has been received.`);
        this.formData = { name: "", email: "", message: "" }; // Reset the form
      },
    },
  };
  </script>
  
  <style scoped>
  .register-form {
    max-width: 400px;
    margin: 2rem auto;
    padding: 10cqmin;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    justify-content: center;
  }
  
  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
    color: #333;
  }
  
  .form-group {
    margin-bottom: 3rem;
  }
  
  label {
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: bold;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
    box-sizing: border-box;
  }
  
  textarea {
    resize: vertical;
    height: 100px;
  }
  
  input:focus,
  textarea:focus {
    outline: none;
    border-color: var(--main-color);
    box-shadow: 0 0 5px var(--main-color);
  }
  
  button.btn {
    width: 100%;
    padding: 0.75rem;
    border: none;
    border-radius: 5px;
    background-color: var(--main-color);
    color: white;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  button.btn:hover {
    background-color: #e60073;
  }
  </style>
  